import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'cc-audio-message-upload',
  templateUrl: './audio-message-upload.component.html',
  styleUrls: ['./audio-message-upload.component.scss']
})
export class AudioMessageUploadComponent implements OnInit {
  @Input() bucketFileName;
  @Input() fileName;
  @Input() fileType;
  @Input() fileUrl;
  @Output() remove = new EventEmitter();
  @Output() update = new EventEmitter();

  constructor(private http: HttpClient, private dialog: MatDialog) {}

  ngOnInit() {}

  onRemove() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'PHONE.MESSAGES.MODAL.HEADER',
          body: 'PHONE.MESSAGES.MODAL.BODY'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.http.delete(this.fileUrl).subscribe(() => {
            this.remove.next();
          });
        }
      });
  }
}
